import React from 'react'
import { tv } from 'tailwind-variants'
import Tooltip from 'components/tooltip'
import { Info } from 'components/icons'

// Merged (tailwind-merge) so a consumer's classes win over these — the colour in particular, since a
// hint sitting in a coloured surface such as a spreadsheet column header inherits that surface's colour.
const hint = tv({ base: 'flex items-center justify-center cursor-help text-faint' })

interface InfoHintProps {
  content: string
  className?: string
}

// A hoverable info (i) icon that reveals its help text — matches the pattern used elsewhere (e.g. the
// spreadsheet header column description). Used by the column configuration forms to keep long
// explanations out of the narrow menus while still offering them on demand.
const InfoHint: React.FC<InfoHintProps> = ({ content, className }) => (
  <Tooltip content={content} className="w-max whitespace-normal break-words max-w-[320px]">
    <div className={hint({ class: className })}>
      <Info className="h-4 w-4" />
    </div>
  </Tooltip>
)

export default InfoHint
